import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { AlertDialog } from "../AlertDialog/AlertDialog";
import { FormattedText } from "../FormattedText/FormattedText";
import { NumberedList } from "../Lists/NumberedList";

export type FindSettingDialogProps = {
	settingName: string;
	newLineSeparatedSteps: string;
	trackingId: string;
	onClose(): void;
};

export const FindSettingDialog = (props: FindSettingDialogProps): ReactElement => {
	const {
		settingName,
		newLineSeparatedSteps,
		trackingId,
		onClose
	} = props;

	const steps: string[] = newLineSeparatedSteps.trim()
		.split(/(?:\r\n|\r|\n)/g);

	return (
		<AlertDialog
			trackingId={trackingId}
			title={
				<FormattedText
					text={localize("_WhereToFindTheSettingName")}
					thingsToReplace={[
						{ what: "{{SettingName}}", filler: settingName }
					]}
				/>
			}
			confirmText={localize("_Close")}
			onClose={onClose}
			showCloseButton
		>
			<NumberedList trackingId="steps">
				{steps.map((text, index) => (
					<NumberedList.Item key={index}>
						{text}
					</NumberedList.Item>
				))}
			</NumberedList>
		</AlertDialog>
	);
};
FindSettingDialog.displayName = "FindSettingDialog";
